import { render, staticRenderFns } from "./AdminNotificationEdit.vue?vue&type=template&id=4d85e7bc"
import script from "./AdminNotificationEdit.vue?vue&type=script&lang=js"
export * from "./AdminNotificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports